let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fx531")).then(() => parcelRequire('dGO9h'));